import {Checkbox} from "@mui/material";
import React from "react";
import {ColorSettings} from "../types/decisions";

const MultiColorSelector = ({colors, onColorChange}: {
    colors: ColorSettings[]; onColorChange: (index: number) => void;
}) => {
    return (
        <>
            {colors.map((color, index) => {
                return (
                    <div key={color.color}>
                        <div
                            style={{
                                border: '1px solid gray',
                                borderRadius: 3,
                                width: 42,
                                height: 42,
                                marginRight: 10,
                                backgroundColor: color.color,
                            }}
                        />
                        <Checkbox checked={color.isSelected} onChange={() => onColorChange(index)}/>
                    </div>
                )
            })}
        </>
    );
};

export default MultiColorSelector;